export default __webpack_public_path__ + "static/media/icon_login4.5020d887.png";